sideMenuHelpButton = {};

sideMenuHelpButton.create = function() {
    var button = new PIXI.Container();
    
    InputHelpers.addGenerics(button);
    InputHelpers.addCanSpinFlag(button);
	
    button.canEnable = function() {
    	return true;
    };
    
    button.onPressedCallback = function() {
        helpPageManager.showPopup(0);

    };

    return button;
};

sideMenuHelpButton.initialise = function(json, object) {
	object.soundName = json.soundName || "";
};
sideMenuHelpButton.getFilesRequired = function() {
	return [];
};

resourceManager.registerObjectType("sideMenuHelpButton", sideMenuHelpButton.create, sideMenuHelpButton.initialise, sideMenuHelpButton.getFilesRequired);